import { toString, Union, Record } from "./fable_modules/fable-library-js.4.24.0/Types.js";
import { User as User_1, UpdatedUser, Workplace_$reflection, User_$reflection } from "./Shared/SharedModels.jsx";
import { union_type, record_type, bool_type, array_type } from "./fable_modules/fable-library-js.4.24.0/Reflection.js";
import { startAsPromise } from "./fable_modules/fable-library-js.4.24.0/Async.js";
import { Workplace, toastServerError, User } from "./ApiClient.jsx";
import { unwrap, toArray, defaultArg, map } from "./fable_modules/fable-library-js.4.24.0/Option.js";
import { successToast, errorToast } from "./Toasts.jsx";
import { createElement } from "react";
import React from "react";
import { useCtx } from "./Context.jsx";
import { reactApi } from "./fable_modules/Feliz.2.9.0/Interop.fs.js";
import { SortDirection } from "./fable_modules/FS.FluentUI.2.5.2/Domain.fs.js";
import { Card, Caption1, Title3, DataGridCell, DataGridBody, DataGridHeader, DataGridHeaderCell, DataGridRow, DataGrid, Checkbox, Button, Text as Text$, Option, Dropdown, Persona, tokens, TableCellLayout, createTableColumn as createTableColumn_6 } from "@fluentui/react-components";
import { compare, compareTo } from "./fable_modules/fable-library-js.4.24.0/String.js";
import { collect, toArray as toArray_1, iterate, empty, singleton, delay, toList } from "./fable_modules/fable-library-js.4.24.0/Seq.js";
import { PersonProhibitedRegular, CheckmarkRegular } from "@fluentui/react-icons";
import { isEmpty, ofArray, singleton as singleton_1 } from "./fable_modules/fable-library-js.4.24.0/List.js";
import { createObj } from "./fable_modules/fable-library-js.4.24.0/Util.js";
import { map as map_1, tryFind } from "./fable_modules/fable-library-js.4.24.0/Array.js";
import { reactApi as reactApi_1 } from "./fable_modules/Feliz.2.9.0/Interop.fs.js";
import { compareTo as compareTo_1 } from "./fable_modules/fable-library-js.4.24.0/Date.js";
import { nb } from "date-fns/locale";
import { format as format_1 } from "date-fns";
import { Checkbox_toBool } from "./fable_modules/FS.FluentUI.2.5.2/Domain.fs.js";
import { dataGrid_items_Z6D8BD2B8 } from "./fable_modules/FS.FluentUI.2.5.2/Props2.fs.js";
import { useEffectOnce } from "./fable_modules/Feliz.2.9.0/Internal.fs.js";
import { AuditLog } from "./AuditTable.jsx";

class Model extends Record {
    constructor(AllUsers, Workplaces, IsFetching, ShowAllUsers) {
        super();
        this.AllUsers = AllUsers;
        this.Workplaces = Workplaces;
        this.IsFetching = IsFetching;
        this.ShowAllUsers = ShowAllUsers;
    }
}

function Model_$reflection() {
    return record_type("ApproveUsers.Model", [], Model, () => [["AllUsers", array_type(User_$reflection())], ["Workplaces", array_type(Workplace_$reflection())], ["IsFetching", bool_type], ["ShowAllUsers", bool_type]]);
}

class Msg extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["UpdateAllUsers", "UpdateWorkplaces", "UpdateIsFetching", "UpdateShowAllUsers"];
    }
}

function Msg_$reflection() {
    return union_type("ApproveUsers.Msg", [], Msg, () => [[["Item", array_type(User_$reflection())]], [["Item", array_type(Workplace_$reflection())]], [["Item", bool_type]], [["Item", bool_type]]]);
}

function update(model, msg) {
    switch (msg.tag) {
        case 1:
            return new Model(model.AllUsers, msg.fields[0], model.IsFetching, model.ShowAllUsers);
        case 2:
            return new Model(model.AllUsers, model.Workplaces, msg.fields[0], model.ShowAllUsers);
        case 3:
            return new Model(model.AllUsers, model.Workplaces, model.IsFetching, msg.fields[0]);
        default:
            return new Model(msg.fields[0], model.Workplaces, model.IsFetching, model.ShowAllUsers);
    }
}

function init() {
    return new Model([], [], true, false);
}

export function updateEnabledUser(user, enabled, callback, setCtx) {
    let pr_1;
    const pr = startAsPromise(User.UpdateUser(user.Id, new UpdatedUser(user.FirstName, user.LastName, enabled, user.IsAdmin, map((_arg) => _arg.Id, user.Workplace))));
    pr_1 = (pr.then((res) => {
        if (res.tag === 1) {
            switch (res.fields[0].tag) {
                case 1: {
                    errorToast(setCtx, `updateUser${user.Id}WorkplaceNotFound`, "Kunne ikke oppdatere bruker", "Ugyldig arbeidsplass", undefined);
                    break;
                }
                case 2: {
                    errorToast(setCtx, `updateUser${user.Id}InvalidName`, "Kunne ikke oppdatere bruker", "Ugyldig navn", undefined);
                    break;
                }
                default:
                    errorToast(setCtx, `updateUser${user.Id}UserNotFound`, "Kunne ikke oppdatere bruker", "Ugyldig bruker", undefined);
            }
        }
        else {
            callback(res.fields[0]);
            successToast(setCtx, `enableUser${user.Id}Success`, "Bruker oppdatert", `Brukeren ${user.FirstName} ${user.LastName} ble oppdatert`);
        }
    }));
    void (pr_1.catch((ex) => {
        toastServerError(setCtx, ex);
    }));
}

export function updateUser(user, callback, setCtx) {
    let pr_1;
    const pr = startAsPromise(User.UpdateUser(user.Id, new UpdatedUser(user.FirstName, user.LastName, user.Enabled, user.IsAdmin, map((_arg) => _arg.Id, user.Workplace))));
    pr_1 = (pr.then((res) => {
        if (res.tag === 1) {
            switch (res.fields[0].tag) {
                case 1: {
                    errorToast(setCtx, `updateUser${user.Id}WorkplaceNotFound`, "Kunne ikke oppdatere bruker", "Ugyldig arbeidsplass", undefined);
                    break;
                }
                case 2: {
                    errorToast(setCtx, `updateUser${user.Id}InvalidName`, "Kunne ikke oppdatere bruker", "Ugyldig navn", undefined);
                    break;
                }
                default:
                    errorToast(setCtx, `updateUser${user.Id}UserNotFound`, "Kunne ikke oppdatere bruker", "Ugyldig bruker", undefined);
            }
        }
        else {
            callback(res.fields[0]);
            successToast(setCtx, `updateUser${user.Id}Success`, "Bruker oppdatert", `Brukeren ${user.FirstName} ${user.LastName} ble oppdatert`);
        }
        return res;
    }));
    void (pr_1.catch((ex) => {
        toastServerError(setCtx, ex);
    }));
}

function UserApprovalTable(userApprovalTableInputProps) {
    let createTableColumn, createTableColumn_1, createTableColumn_2, createTableColumn_3, createTableColumn_4, createTableColumn_5, elems_4, el_42, el_52, tupledArg, value_173, elems_3, props_65, el_44, name_3, el_50;
    const dispatch = userApprovalTableInputProps.dispatch;
    const model = userApprovalTableInputProps.model;
    const setCtx = useCtx()[1];
    const patternInput_1 = reactApi.useState(["approved", new SortDirection(0, [])]);
    const columns = ofArray([(createTableColumn = createTableColumn_6, createTableColumn({
        columnId: "approved",
        compare: (delegateArg, delegateArg_1) => compareTo(toString(delegateArg.Enabled), toString(delegateArg_1.Enabled)),
        renderHeaderCell: () => "",
        renderCell: (delegateArg_3) => {
            const user = delegateArg_3;
            const el_2 = TableCellLayout;
            return createElement(el_2, {
                key: `${user.FirstName}-approved`,
                children: toList(delay(() => {
                    let el;
                    return (user.Enabled && (user.Workplace != null)) ? singleton((el = CheckmarkRegular, createElement(el, {
                        primaryFill: tokens.colorBrandForeground2,
                    }))) : empty();
                })),
            });
        },
    })), (createTableColumn_1 = createTableColumn_6, createTableColumn_1({
        columnId: "name",
        compare: (delegateArg_4, delegateArg_1_1) => {
            const a_1 = delegateArg_4;
            const b_1 = delegateArg_1_1;
            return compare(`${a_1.FirstName} ${a_1.LastName}`, `${b_1.FirstName} ${b_1.LastName}`) | 0;
        },
        renderHeaderCell: () => "Navn",
        renderCell: (delegateArg_6) => {
            let el_4;
            const user_1 = delegateArg_6;
            const el_6 = TableCellLayout;
            return createElement(el_6, {
                key: `${user_1.FirstName} ${user_1.LastName}`,
                children: singleton_1((el_4 = Persona, createElement(el_4, {
                    size: "small",
                    avatar: {
                        image: {
                            src: defaultArg(user_1.ImageUrl, ""),
                        },
                    },
                    name: `${user_1.FirstName} ${user_1.LastName}`,
                }))),
            });
        },
    })), (createTableColumn_2 = createTableColumn_6, createTableColumn_2({
        columnId: "workplace",
        compare: (delegateArg_7, delegateArg_1_2) => {
            const matchValue = delegateArg_7.Workplace;
            const matchValue_1 = delegateArg_1_2.Workplace;
            if (matchValue != null) {
                if (matchValue_1 != null) {
                    const x = matchValue;
                    const y = matchValue_1;
                    return compare(x.Name, y.Name) | 0;
                }
                else {
                    return 1;
                }
            }
            else if (matchValue_1 != null) {
                return -1;
            }
            else {
                return 0;
            }
        },
        renderHeaderCell: () => "Arbeidsplass",
        renderCell: (delegateArg_9) => {
            let el_12, elems_1;
            const user_2 = delegateArg_9;
            const el_14 = TableCellLayout;
            return createElement(el_14, {
                key: defaultArg(map((_arg_3) => _arg_3.Name, user_2.Workplace), "Missing"),
                children: singleton_1((el_12 = Dropdown, createElement(el_12, createObj(ofArray([["size", "small"], ["style", {
                    minWidth: 150,
                }], ["appearance", "underline"], ["value", defaultArg(map((_arg_4) => _arg_4.Name, user_2.Workplace), "")], ["onOptionSelect", (_arg_5, value_1_22) => {
                    iterate((selected) => {
                        updateUser(new User_1(user_2.Id, user_2.KeycloakId, user_2.FirstName, user_2.LastName, user_2.Enabled, user_2.IsAdmin, user_2.ImageUrl, tryFind((wp) => (wp.Name === selected), model.Workplaces), user_2.Inserted), (updatedUser) => {
                            dispatch(new Msg(0, [map_1((u) => {
                                if (u.Id === updatedUser.Id) {
                                    return updatedUser;
                                }
                                else {
                                    return u;
                                }
                            }, model.AllUsers)]));
                        }, setCtx);
                    }, toArray(value_1_22.optionValue));
                }], (elems_1 = toList(delay(() => map_1((wp_2) => {
                    let elems, el_8;
                    const el_10 = Option;
                    return createElement(el_10, createObj(ofArray([["text", wp_2.Name], ["disabled", defaultArg(map((userWp) => (userWp.Id === wp_2.Id), user_2.Workplace), false)], ["value", wp_2.Name], (elems = [(el_8 = Text$, createElement(el_8, {
                        children: wp_2.Name,
                        wrap: false,
                    }))], ["children", reactApi_1.Children.toArray(Array.from(elems))])])));
                }, model.Workplaces))), ["children", reactApi_1.Children.toArray(Array.from(elems_1))])]))))),
            });
        },
    })), (createTableColumn_3 = createTableColumn_6, createTableColumn_3({
        columnId: "inserted",
        compare: (delegateArg_10, delegateArg_1_3) => compareTo_1(delegateArg_10.Inserted, delegateArg_1_3.Inserted),
        renderHeaderCell: () => "Opprettet",
        renderCell: (delegateArg_12) => {
            let el_16, locale, formatOptions;
            const user_3 = delegateArg_12;
            const el_18 = TableCellLayout;
            return createElement(el_18, {
                key: toString(user_3.Inserted),
                children: singleton_1((el_16 = Text$, createElement(el_16, {
                    children: `${(locale = nb, (formatOptions = {}, (formatOptions.locale = locale, format_1(user_3.Inserted, "dd MMMM yyyy", formatOptions))))}`,
                }))),
            });
        },
    })), (createTableColumn_4 = createTableColumn_6, createTableColumn_4({
        columnId: "status",
        renderHeaderCell: () => "Status",
        renderCell: (delegateArg_14) => {
            const user_4 = delegateArg_14;
            const el_30 = TableCellLayout;
            return createElement(el_30, {
                key: `${user_4.Id}-status`,
                children: toList(delay(() => {
                    let el_20, el_22, el_24, el_26, el_28;
                    return user_4.IsAdmin ? singleton((el_20 = Text$, createElement(el_20, {
                        children: "Administrator",
                    }))) : ((user_4.Enabled && (user_4.Workplace == null)) ? singleton((el_22 = Text$, createElement(el_22, {
                        children: "Mangler arbeidsplass",
                    }))) : ((!user_4.Enabled && (user_4.Workplace == null)) ? singleton((el_24 = Text$, createElement(el_24, {
                        children: "Mangler arbeidsplass",
                    }))) : ((!user_4.Enabled && (user_4.Workplace != null)) ? singleton((el_26 = Text$, createElement(el_26, {
                        children: "Mangler godkjenning",
                    }))) : ((user_4.Enabled && (user_4.Workplace != null)) ? singleton((el_28 = Text$, createElement(el_28, {
                        children: "",
                    }))) : empty()))));
                })),
            });
        },
    })), (createTableColumn_5 = createTableColumn_6, createTableColumn_5({
        columnId: "approve",
        renderHeaderCell: () => "",
        renderCell: (delegateArg_16) => {
            const user_5 = delegateArg_16;
            const el_40 = TableCellLayout;
            return createElement(el_40, {
                key: `approve-${user_5.Id}`,
                children: toList(delay(() => {
                    let el_34, el_32, el_38, el_36;
                    return !user_5.Enabled ? singleton((el_34 = Button, createElement(el_34, {
                        disabled: user_5.Workplace == null,
                        size: "small",
                        children: "Godkjenn",
                        icon: (el_32 = CheckmarkRegular, createElement(el_32, {})),
                        onClick: (_arg_9) => {
                            updateEnabledUser(user_5, true, (_arg_10) => {
                                dispatch(new Msg(0, [map_1((u_1) => {
                                    if (user_5.Id === u_1.Id) {
                                        return new User_1(user_5.Id, user_5.KeycloakId, user_5.FirstName, user_5.LastName, true, user_5.IsAdmin, user_5.ImageUrl, user_5.Workplace, user_5.Inserted);
                                    }
                                    else {
                                        return u_1;
                                    }
                                }, model.AllUsers)]));
                            }, setCtx);
                        },
                        appearance: "primary",
                    }))) : singleton((el_38 = Button, createElement(el_38, {
                        disabled: user_5.Workplace == null,
                        size: "small",
                        children: "Sett inaktiv",
                        icon: (el_36 = PersonProhibitedRegular, createElement(el_36, {})),
                        onClick: (_arg_11) => {
                            updateEnabledUser(user_5, false, (_arg_12) => {
                                dispatch(new Msg(0, [map_1((u_2) => {
                                    if (user_5.Id === u_2.Id) {
                                        return new User_1(user_5.Id, user_5.KeycloakId, user_5.FirstName, user_5.LastName, false, user_5.IsAdmin, user_5.ImageUrl, user_5.Workplace, user_5.Inserted);
                                    }
                                    else {
                                        return u_2;
                                    }
                                }, model.AllUsers)]));
                            }, setCtx);
                        },
                    })));
                })),
            });
        },
    }))]);
    return createElement("div", createObj(singleton_1((elems_4 = [(el_42 = Checkbox, createElement(el_42, {
        checked: model.ShowAllUsers,
        onChange: (_arg_13, c) => {
            dispatch(new Msg(3, [Checkbox_toBool(c)]));
        },
        label: "Vis alle brukere",
    })), (el_52 = DataGrid, createElement(el_52, createObj(ofArray([dataGrid_items_Z6D8BD2B8(model.AllUsers.filter((u_3) => {
        if (!model.ShowAllUsers) {
            return !u_3.Enabled;
        }
        else {
            return true;
        }
    })), ["columns", toArray_1(columns)], ["sortable", true], ["resizableColumnsOptions", {
        autoFitColumns: true,
    }], (tupledArg = patternInput_1[0], ["sortState", {
        sortColumn: unwrap(tupledArg[0]),
        sortDirection: tupledArg[1],
    }]), ["onSortChange", (delegateArg_17, delegateArg_1_4) => {
        const sortState_1 = delegateArg_1_4;
        patternInput_1[1]([sortState_1.sortColumn, sortState_1.sortDirection]);
    }], ["resizableColumns", true], (value_173 = ofArray([["approved", ofArray([["minWidth", 20], ["defaultWidth", 20], ["idealWidth", 20]])], ["workplace", ofArray([["minWidth", 125], ["defaultWidth", 150], ["idealWidth", 200]])]]), ["columnSizingOptions", isEmpty(value_173) ? {} : createObj(toList(delay(() => collect((matchValue_3) => singleton([matchValue_3[0], createObj(matchValue_3[1])]), value_173))))]), (elems_3 = [(props_65 = singleton_1((el_44 = DataGridRow, createElement(el_44, {
        children: (delegateArg_18, delegateArg_1_5) => {
            const props_60 = singleton_1(delegateArg_18.renderHeaderCell());
            const name_1 = DataGridHeaderCell;
            return createElement(name_1, {
                children: reactApi.Children.toArray(Array.from(props_60)),
            });
        },
    }))), (name_3 = DataGridHeader, createElement(name_3, {
        children: reactApi.Children.toArray(Array.from(props_65)),
    }))), (el_50 = DataGridBody, createElement(el_50, {
        children: (delegateArg_20) => {
            const trd = delegateArg_20;
            const el_48 = DataGridRow;
            return createElement(el_48, {
                key: trd.rowId,
                children: (delegateArg_19, delegateArg_1_6) => {
                    let elems_2;
                    const tcd_1 = delegateArg_19;
                    const el_46 = DataGridCell;
                    return createElement(el_46, createObj(ofArray([["key", tcd_1.columnId], (elems_2 = [tcd_1.renderCell(trd.item)], ["children", reactApi_1.Children.toArray(Array.from(elems_2))])])));
                },
            });
        },
    }))], ["children", reactApi_1.Children.toArray(Array.from(elems_3))])]))))], ["children", reactApi.Children.toArray(Array.from(elems_4))]))));
}

export function View() {
    let elems_4, elems_1, elems, el, el_2, el_4, elems_2, el_6, elems_3;
    const setCtx = useCtx()[1];
    let patternInput_1;
    const arg_1 = init();
    patternInput_1 = reactApi.useReducer(update, arg_1);
    const dispatch = patternInput_1[1];
    useEffectOnce(() => {
        let pr_1;
        const pr = startAsPromise(User.GetAll());
        pr_1 = (pr.then((res) => {
            if (res.tag === 1) {
                dispatch(new Msg(2, [false]));
            }
            else {
                dispatch(new Msg(0, [res.fields[0]]));
                dispatch(new Msg(2, [false]));
            }
            return res;
        }));
        void (pr_1.catch((ex) => {
            toastServerError(setCtx, ex);
        }));
        let pr_3;
        const pr_2 = startAsPromise(Workplace.GetAllWorkplaces());
        pr_3 = (pr_2.then((res_1) => {
            if (res_1.tag === 1) {
                errorToast(setCtx, "fetchWorkplacesError", "Noe gikk galt", "Kunne ikke hente arbeidsplasser", undefined);
            }
            else {
                dispatch(new Msg(1, [res_1.fields[0]]));
            }
            return res_1;
        }));
        void (pr_3.catch((ex_1) => {
            toastServerError(setCtx, ex_1);
        }));
    });
    return createElement("div", createObj(ofArray([["style", {
        display: "flex",
        flexDirection: "column",
        flexGrow: 1,
        gap: 25 + "px ",
    }], (elems_4 = [createElement("div", createObj(ofArray([["style", {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
    }], (elems_1 = [createElement("div", createObj(ofArray([["style", {
        display: "flex",
        flexDirection: "column",
    }], (elems = [(el = Title3, createElement(el, {
        children: "Godkjenninger",
    })), (el_2 = Caption1, createElement(el_2, {
        style: {
            color: tokens.colorNeutralForeground3,
        },
        children: "Brukere som venter på å bli godkjent",
    }))], ["children", reactApi.Children.toArray(Array.from(elems))])])))], ["children", reactApi.Children.toArray(Array.from(elems_1))])]))), (el_4 = Card, createElement(el_4, createObj(singleton_1((elems_2 = [createElement(UserApprovalTable, {
        model: patternInput_1[0],
        dispatch: dispatch,
    })], ["children", reactApi_1.Children.toArray(Array.from(elems_2))]))))), (el_6 = Card, createElement(el_6, createObj(singleton_1((elems_3 = [createElement(AuditLog, {
        tableName: "user",
    })], ["children", reactApi_1.Children.toArray(Array.from(elems_3))])))))], ["children", reactApi.Children.toArray(Array.from(elems_4))])])));
}

//# sourceMappingURL=ApproveUsers.jsx.map
